import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import BackToTop from "@/components/feature/BackToTop";
import Hero from "./components/Hero";
import Features from "./components/Features";
import RelationsSpotlight from "./components/RelationsSpotlight";
import CpTimeline from "./components/CpTimeline";
import DailyFeed from "./components/DailyFeed";
import SecretLines from "./components/SecretLines";
import FaqSection from "./components/FaqSection";

export default function Home() {
  return (
    <>
      <Navbar />
      <main>
        <Hero />
        <Features />
        <RelationsSpotlight />
        <CpTimeline />
        <DailyFeed />
        <SecretLines />
        <FaqSection />
      </main>
      <Footer />
      <BackToTop />

      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            "@context": "https://schema.org",
            "@type": "WebPage",
            name: "师兄啊师兄人物关系百科",
            description:
              "师兄关系亲疏、师姐互动名场面、同门情谊暗线全梳理，CP线发展脉络与师门日常细节同步更新。",
            inLanguage: "zh-CN",
          }),
        }}
      />
    </>
  );
}